module.exports = __webpack_public_path__ + "static/media/IMG_0538.e43ba7d9.jpg";